// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const StockCheckCirclePreBook: React.FC<{ width?: number; height?: number; color1?: string; className?: string }> = ({
    width = undefined,
    height = undefined,
    color1 = "#415465",
    className,
}) => {
    return (
        <svg className={className} focusable="false" viewBox="0 0 12 13" width={width} height={height}>
            <path
                fill="currentColor"
                d="M6 1.25a5.25 5.25 0 1 1 0 10.5 5.25 5.25 0 0 1 0-10.5M6 12.5a6 6 0 1 0 0-12 6 6 0 0 0 0 12m2.515-7.235a.376.376 0 0 0 0-.53.376.376 0 0 0-.53 0L5.25 7.47 4.015 6.235a.376.376 0 0 0-.53 0 .376.376 0 0 0 0 .53l1.5 1.5a.376.376 0 0 0 .53 0z"
            />
        </svg>
    );
};

export default React.memo(StockCheckCirclePreBook);
